import styled from "styled-components";

export default styled.div`
  position: relative;
  margin: 0.6em 0;
`;
